import { useContext } from "@nuxtjs/composition-api";
const defaultImageSizes = {
  productCard: {
    width: 216,
    height: 268
  },
  card: {
    width: 400,
    height: 400
  },
  productCardHorizontal: {
    width: 140,
    height: 200
  },
  checkout: {
    imageWidth: 100,
    imageHeight: 100
  },
  productGallery: {
    thumbWidth: 80,
    thumbHeight: 80,
    imageWidth: 700,
    imageHeight: 700
  },
  cart: {
    imageWidth: 170,
    imageHeight: 170
  }
};
function useImage() {
  var _a, _b;
  const context = useContext();
  const themeImageSizes = ((_b = (_a = context.app.$wm) == null ? void 0 : _a.theme) == null ? void 0 : _b.imageSizes) || {};
  const imageSizes = {
    ...defaultImageSizes,
    ...themeImageSizes
  };
  const getMagentoImage = (fullImageUrl) => {
    if (!fullImageUrl)
      return "";
    fullImageUrl = fullImageUrl.replace(".renditions", "");
    const { imageProvider, magentoBackendBaseUrl } = context.$vsf.$magento.config;
    if (imageProvider !== "ipx") {
      const url = fullImageUrl.split(`${magentoBackendBaseUrl}`);
      const regex = /cache\/(.*?)\//gm;
      return url[1].replace(regex, "");
    } else if (imageProvider === "ipx" && context.$config["magentoImageAlias"]) {
      fullImageUrl = fullImageUrl.replace(magentoBackendBaseUrl, "");
      fullImageUrl = fullImageUrl.startsWith("/") ? fullImageUrl : "/" + fullImageUrl;
      fullImageUrl = "/" + context.$config["magentoImageAlias"] + (fullImageUrl.startsWith("/media") ? "" : "/media") + fullImageUrl;
    } else {
      if (!fullImageUrl.startsWith(magentoBackendBaseUrl)) {
        fullImageUrl = fullImageUrl.startsWith("/") ? fullImageUrl : "/" + fullImageUrl;
        fullImageUrl = magentoBackendBaseUrl + (fullImageUrl.startsWith("/media") ? "" : "/media") + fullImageUrl;
      }
    }
    return fullImageUrl;
  };
  return {
    getMagentoImage,
    imageSizes
  };
}
export * from "./useImage";
var useImage_default = useImage;
export {
  useImage_default as default,
  useImage
};
